import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import PreviewCertificate from "../pages/User/Certificate/PreviewCertificate/PreviewCertificate";
import CertificateList from "../pages/User/Certificate/CertificateList/CertificateList";

var NormalUserRoutes = [
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default NormalUserRoutes;
